// extracted by mini-css-extract-plugin
module.exports = {"auth-layout-wrapper":"AuthLayout_auth-layout-wrapper__72uz7"};